var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2672 1.37891C16.8744 1.37891 17.3672 1.87171 17.3672 2.47891V5.77891H21.7672C22.3744 5.77891 22.8672 6.27171 22.8672 6.87891V22.2789C22.8672 22.8861 22.3744 23.3789 21.7672 23.3789H1.96719C1.35999 23.3789 0.867188 22.8861 0.867188 22.2789V6.87891C0.867188 6.27171 1.35999 5.77891 1.96719 5.77891H6.36719V2.47891C6.36719 1.87171 6.85999 1.37891 7.46719 1.37891H16.2672ZM20.6672 7.97891H3.06719V21.1789H20.6672V7.97891ZM12.9672 10.1789V13.4789H16.2672V15.6789H12.9661L12.9672 18.9789H10.7672L10.7661 15.6789H7.46719V13.4789H10.7672V10.1789H12.9672ZM15.1672 3.57891H8.56719V5.77891H15.1672V3.57891Z",
    fill: "#AB882E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalIcon);
export default __webpack_public_path__ + "static/media/medicalIcon.d2fa28e8d028fd259af6d2062e606d7b.svg";
export { ForwardRef as ReactComponent };